import React from "react";
import Footer from "../../Footer/Footer";
import ProfileNavbar from "../../Navbar/ProfileNavbar";
import SideBar from "../SideBar/SideBar";

const Dashboad = () => {
  return (
    <div className="chart">
      <ProfileNavbar />
      <SideBar />
      <Footer />
    </div>
  );
};

export default Dashboad;
